import styled from "@emotion/styled";
import { Box, Grid, Paper } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { useCallback, useEffect, useState } from "react";
import { DateRangesFilterProps } from "./types";

const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: "#fff",
	//@ts-expect-error - Property 'typography' does not exist on type 'Theme'
	...theme.typography.body2,
	//@ts-expect-error - Property 'spacing' does not exist on type 'Theme'
	padding: theme.spacing(2),
	textAlign: "center",
	//@ts-expect-error - Property 'palette' does not exist on type 'Theme'
	color: theme.palette.text.secondary,
	//@ts-expect-error - Property 'applyStyles' does not exist on type 'Theme'
	...theme.applyStyles("dark", {
		backgroundColor: "#1A2027",
	}),
}));

export default function DateRangesFilter(props: DateRangesFilterProps) {
	const { onDateChange } = props;
	const [startDate, setStartDate] = useState<Dayjs | null>(dayjs("2022-04-17"));
	const [endDate, setEndDate] = useState<Dayjs | null>(dayjs("2022-04-17"));

	const handleDateChange = useCallback(
		(date: Dayjs | null, prop: "startDate" | "endDate") => {
			if (prop === "startDate") {
				setStartDate(date);
			} else if (prop === "endDate") {
				setEndDate(date);
			}

			onDateChange(date, prop);
		},
		[setStartDate, setEndDate, onDateChange]
	);

	useEffect(() => {
		// SetStartDate as today date minus 1 day
		const today = dayjs();
		const yesterday = today.subtract(1, "day");

		setStartDate(yesterday);
		onDateChange(yesterday, "startDate");

		// SetEndDate as today date
		setEndDate(today);
		onDateChange(today, "endDate");
	}, []);

	return (
		<Box sx={{ flexGrow: 1, width: "100%" }}>
			<Grid
				container
				sx={{ textAlign: "center", display: "flex", justifyContent: "center" }}
				spacing={{ xs: 2, md: 3 }}
				columns={{ xs: 4, sm: 8, md: 12 }}>
				<Grid item xs={12} sm={4} md={4}>
					<DatePicker
						value={startDate}
						onChange={(newValue) => handleDateChange(newValue, "startDate")}
						label={"Fecha Inicio"}
					/>
				</Grid>
				<Grid item xs={12} sm={4} md={4}>
					<DatePicker
						value={endDate}
						onChange={(newValue) => handleDateChange(newValue, "endDate")}
						label={"Fecha Fin"}
					/>
				</Grid>
			</Grid>
		</Box>
	);
}
